var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('el-backtop',{ref:"globalBakcTop",staticStyle:{"width":"0","height":"0","box-shadow":"none"},attrs:{"right":0,"bottom":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }